import state from './support.state'
import mutations from './support.mutations'
import actions from './support.actions'

export default {
  state,
  mutations,
  actions
}
